exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.translucent-card-width[data-v-05f01ea2] {\n  width: calc(100% - 685px);\n}\n.translucent-card-thin-menu-width[data-v-05f01ea2] {\n  width: calc(100% - 533px);\n}\n.translucent-card .error-num-message[data-v-05f01ea2] {\n  font-size: 14px;\n}\n.translucent-card .icon-wrapper[data-v-05f01ea2] {\n  position: absolute;\n  top: 0px;\n  right: 16px;\n}\n.translucent-card .arrow-circle-wrapper[data-v-05f01ea2] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-05f01ea2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/organisms/chatbot/footers/ScenarioErrorFooter.vue
// module id = P3Ah
// module chunks = 3